import { Toast, ToastType } from 'types/toasts'

// Toasts
export const SUCCESS_TOAST: Toast = {
  title: 'Success!',
  message: 'Shares bought successfully!',
  type: ToastType.Success,
}

export const SUCCESS_TOAST_DEMAND: Toast = {
  title: 'Success!',
  message: 'Buy On Demand order success! Shares will be added within 24-48 hours.',
  type: ToastType.Success,
}

export const SUCCESS_TOAST_BurnAndBridge: Toast = {
    title: 'Success!',
    message: 'WPOKT was bridged to Pocket Network successfully! Shares will be updated in the next few hours.',
    type: ToastType.Success,
    chain: '0x1',
}

export const ERROR_TOAST: Toast = {
  title: 'Unexpected Buy Error.',
  message: 'The shares could not be bought.',
  type: ToastType.Error,
}

export const APPROVE_SUCCESS_TOAST: Toast = {
  title: 'Success!',
  message: 'Your USDC was successfully approved!',
  type: ToastType.Success,
}

export const APPROVE_ETH_SUCCESS_TOAST: Toast = {
    title: 'Success!',
    message: 'Your WPOKT was successfully approved!',
    type: ToastType.Success,
    chain: '0x1',
}

export const APPROVE_ERROR_TOAST: Toast = {
  title: 'Unexpected Approve Error.',
  message: 'USDC approve failed. USDC balance can not be zero.',
  type: ToastType.Error,
}

export const APPROVE_ETH_ERROR_TOAST: Toast = {
  title: 'Unexpected Approve Error.',
  message: 'WPOKT approve failed. WPOKT balance can not be zero.',
  type: ToastType.Error,
}

export const SHARES_INFO =
  'Shares are your staked POKT into the node. Buy them with WPOKT on Ethereum or with USDC on Fantom.'

export const DISABLED_INFO_HOLDER_ACTIONS = 'Holder actions disabled.'

export const DISABLED_INFO_BALANCE = 'Not enough funds.'

export const DISABLED_INFO_MINDEMAND = 'Min amount of '

export const DISABLED_INFO_DISCONNECTED = 'Connect to buy shares.'
